import { NgModule } from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LeagueStartPageComponent} from '@modules/league/pages/league-start-page/league-start-page.component';
import {NewsResolver} from '@modules/home/tabs/news/resolvers/news-resolver.service';
import {LeagueNewsComponent} from '@modules/league/pages/league-news/league-news.component';
import {TeamTableComponent} from '@modules/team/pages/team-table/team-table.component';
import {LeagueTeamsComponent} from '@modules/league/pages/league-teams/league-teams.component';
import {LeagueRoutes} from '@app/routes/league.routes';
import {GameDetailRoutes} from '@app/routes/game-detail.routes';
import {NewsDetailComponent} from '@shared/modules/shared-news-detail/components/news-detail/news-detail.component';
import {LeagueVideosComponent} from '@modules/league/pages/league-videos/league-videos.component';
import {LeagueStatisticsComponent} from '@modules/league/pages/league-statistics/league-statistics.component';
import {LeagueTransfersComponent} from '@modules/league/pages/league-transfers/league-transfers.component';
import { LeagueMatchesWrapperComponent } from './pages/league-matches-wrapper/league-matches-wrapper.component';
import { LeagueMatchesComponent } from './pages/league-matches/league-matches.component';
import {LeagueHomeComponent} from '@modules/league/pages/league-home/league-home.component';
import {LeagueReplaysComponent} from '@modules/league/pages/league-replays/league-replays.component';
import {LeagueLivestreamsComponent} from '@modules/league/pages/league-livestreams/league-livestreams.component';

export const routes: Routes = [
  {
    path: '',
    component: LeagueStartPageComponent,
    children: [
      { path: '', pathMatch: 'full', component: LeagueHomeComponent},
      { path: LeagueRoutes.news.root, component: LeagueNewsComponent},
      { path: LeagueRoutes.news.detail, component: NewsDetailComponent, resolve: {newsEntry: NewsResolver} },
      {
        path: LeagueRoutes.games.root,
        component: LeagueMatchesWrapperComponent,
        children: [
          { path: '', redirectTo: LeagueRoutes.games.upcoming, pathMatch: 'full' },
          {
            path: LeagueRoutes.games.upcoming,
            component: LeagueMatchesComponent,
            data: { future: true }
          },
          {
            path: LeagueRoutes.games.past,
            component: LeagueMatchesComponent,
            data: { future: false }
          },
        ],
      },
      {
        path: GameDetailRoutes.root.default,
        loadChildren: () => import('@modules/game-detail/game-detail.module').then(m => m.GameDetailModule),
      },
      { path: LeagueRoutes.videos.root, component: LeagueVideosComponent },
      { path: LeagueRoutes.videos.live, component: LeagueLivestreamsComponent },
      { path: LeagueRoutes.videos.replay, component: LeagueReplaysComponent },
      { path: LeagueRoutes.table, component: TeamTableComponent },
      { path: LeagueRoutes.transfers, component: LeagueTransfersComponent },
      { path: LeagueRoutes.statistics, component: LeagueStatisticsComponent },
      { path: LeagueRoutes.clubTeams, component: LeagueTeamsComponent },
      { path: '**', redirectTo: '/404' },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeagueRouting { }
